import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerDownRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowCornerDownRight"><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 4V14.5H18.4393L15.1893 11.25L16.25 10.1893L21.3107 15.25L16.25 20.3107L15.1893 19.25L18.4393 16H3V4H4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerDownRight;
